import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILED,
  LOGOUT_USER,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILED,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILED,
  RESET_FORGOT_PASSWORD,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILED,
  DAILY_3WORDS_REQUEST,
  DAILY_3WORDS_SUCCESS,
  DAILY_3WORDS_FAILED,
} from './constants';

export const loginUser = (username, password) => ({
  type: LOGIN_USER,
  payload: { username, password },
});

export const loginUserSuccess = (user) => ({
  type: LOGIN_USER_SUCCESS,
  payload: user,
});

export const loginUserFailed = (error) => ({
  type: LOGIN_USER_FAILED,
  payload: error,
});

export const registerUser = (fullname, email, password) => ({
  type: REGISTER_USER,
  payload: { fullname, email, password },
});

export const registerUserSuccess = (user) => ({
  type: REGISTER_USER_SUCCESS,
  payload: user,
});

export const registerUserFailed = (error) => ({
  type: REGISTER_USER_FAILED,
  payload: error,
});

export const logoutUser = (history) => ({
  type: LOGOUT_USER,
  payload: { history },
});

// Forgot Password Actions
export const forgotPasswordRequest = (email) => ({
  type: FORGOT_PASSWORD_REQUEST,
  payload: { email },
});

export const forgotPasswordSuccess = (response) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: response,
});

export const forgotPasswordFailed = (error) => ({
  type: FORGOT_PASSWORD_FAILED,
  payload: error,
});

export const resetForgotPasswordState = () => ({
  type: RESET_FORGOT_PASSWORD,
});

// Change Password Actions
export const changePasswordRequest = ({email, passcode, password}) => ({
  type: CHANGE_PASSWORD,
  payload: { email, passcode, password },
});

export const changePasswordSuccess = (response) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: response,
});

export const changePasswordFailed = (error) => ({
  type: CHANGE_PASSWORD_FAILED,
  payload: error,
});

// Daily3Words Actions
export const daily3wordsRequest = () => ({
  type: DAILY_3WORDS_REQUEST,
});

export const daily3wordsSuccess = (words) => ({
  type: DAILY_3WORDS_SUCCESS,
  payload: words,
});

export const daily3wordsFailed = (error) => ({
  type: DAILY_3WORDS_FAILED,
  payload: error,
});
